import React, { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { createCheckout } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function DiagnosticPaywall({ sessionId, info }) {
  const [busy, setBusy] = useState(false);
  const { user } = useAuth();
  const pay = async () => {
    setBusy(true);
    try {
      const { checkout_url } = await createCheckout({ session_id: sessionId, item: "diagnostic" });
      window.location.href = checkout_url;
    } catch (ex) {
      toast.error(ex?.response?.data?.detail || "Could not open checkout.");
      setBusy(false);
    }
  };
  return (
    <section data-testid="diagnostic-paywall" className="rounded-2xl bg-white border border-sky-200 p-5">
      <div className="font-display text-lg font-bold text-[#092C15]">Fair-use limit reached</div>
      <p className="mt-1 text-sm text-slate-600">
        {info.message} Your photos are saved. This diagnosis is a one-time ${Number(info.price).toFixed(2)} — no subscription.
      </p>
      <Button data-testid="diagnostic-pay-button" onClick={pay} disabled={busy} className="mt-4 w-full h-12 rounded-xl font-semibold bg-sky-600 hover:bg-sky-700">
        {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <CreditCard size={16} className="mr-2" />}
        {user?.is_admin ? "Get My Diagnosis Free (Admin — no card)" : <>Pay ${Number(info.price).toFixed(2)} &amp; Get My Diagnosis</>}
      </Button>
    </section>
  );
}
